/**
 * Returns and refunds.
 *
 * Deliberately empty. The staging workbook's RETURNS sheet carries a refund
 * amount, a processor fee, a platform cost and a rider payout that survives the
 * refund — none of which belongs in commission, and none of which CenoX models
 * yet. An empty screen that says what is missing is honest; a screen showing
 * zeroes would claim there have been no returns.
 */

import type { ReactNode } from 'react';
import { Card, EmptyState } from '../../components/ui';
import { SectionTitle } from './parts';

export function LogisticsReturnsPage(): ReactNode {
  return (
    <div className="space-y-4">
      <EmptyState
        title="Returns are not tracked yet"
        description="Nothing on this screen is a zero — returns simply have no home in CenoX yet, and showing them as nil would be a claim rather than a gap."
      />

      <Card>
        <SectionTitle>What a return will need to carry</SectionTitle>
        <ul className="space-y-1.5 text-sm text-slate-600">
          <li>• The delivery it reverses, and what the customer originally paid.</li>
          <li>• The refund amount, which may be partial.</li>
          <li>• The rider&rsquo;s payout, which a refund does not undo — the ride happened.</li>
          <li>• The processor fee, which the provider keeps either way.</li>
          <li>• The resulting platform cost, as its own figure.</li>
        </ul>
        <p className="mt-3 text-xs text-slate-500">
          Kept out of commission on purpose. A refund loss folded into commission would make a
          rider&rsquo;s rate look wrong for a reason that has nothing to do with the rate.
        </p>
      </Card>
    </div>
  );
}
